import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { blogsList } from '../services/General-service';

const sanitizeText = (str) => {
    if (!str) return '';
    return str.replace(/\uFFFD/g, '');
};

function FirstLookBlog() {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        blogsList({ limit: 6 })
            .then((data) => {
                const list = Array.isArray(data?.data) ? data.data : [];
                setBlogs(list.slice(0, 6));
            })
            .catch((error) => {
                console.error('Error fetching first look blogs:', error);
            });
    }, []);

    if (blogs.length === 0) return null;

    return (
        <div className="first-look-blog-shade">
            <div className="App">
                <div className="BreakPointContainer">
                    <div className="CarouselSectionContainer first-look-blog">
                        <div className="SectionTitle first-look-blog-heading">
                            <h1 className="m-t-0 m-b-0 demi-bold">FIRST LOOK BLOG</h1>
                        </div>
                        <div className="first-look-blog-grid">
                            {blogs.map((data) => (
                                <Link
                                    to={`/blogdetails/${data.id}`}
                                    className="first-look-blog-item"
                                    key={data.id}
                                >
                                    <div className="first-look-blog-thumb">
                                        <img
                                            src={data.blog_thumb_img}
                                            alt={sanitizeText(data.blog_title)}
                                        />
                                    </div>
                                    <div className="first-look-blog-content">
                                        <div className="first-look-blog-title h5 text-uppercase demi-bold">
                                            {sanitizeText(data.blog_title)}
                                        </div>
                                        <div className="first-look-blog-desc">
                                            {sanitizeText(data.blog_short_desc)}
                                        </div>
                                        <div className="first-look-blog-date">
                                            {data.blog_date}
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                        <div className="first-look-blog-cta">
                            <Link to="/blogs" className="first-look-blog-all-btn">
                                READ ALL STORIES
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FirstLookBlog;
